import React from "react";
import styles from "./index.module.css";
import { joinClass } from "../../helpers/utils";

const Modal = ({
  children,
  isOpen,
  onCancel,
  bottomModal,
  leftModal,
  fullModal,
  fromBottom,
  modalV2,
}) => {
  return (
    <div
      className={joinClass(styles.modal_overlay, styles.modal_overlayed)}
      onClick={onCancel}
    >
      <div
        className={joinClass(
          styles.modal,
          bottomModal && styles.bottom_modal,
          leftModal && styles.left_modal,
          fullModal && styles.full_modal,
          fromBottom && styles.from_bottom,
          modalV2 && styles.modal_new
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
